import React from 'react'
import Page from '../../../../../ui/Page'
import { Button, Form, Input, Modal, Select, Space, Table } from 'antd'
import { EyeOutlined } from '@ant-design/icons';
import useFetchData from '../../../../../hooks/useFetchData';
import { CollationStatementApproveDto } from '../../../../../interfaces/LearningAgreementDto';
import { AcademicMobilityCompetitionService } from '../../../../../services/AcademicMobilityCompetitionService';
import useModal from '../../../../../ui/Modal/useModal';
import { successNotification } from '../../../../../helpers/successNotification';
import { useHistory } from 'react-router-dom';

const CollationStatementPage = () => {
    const { data: collationStatements, fetchData: fetchCollationStatements } = useFetchData<CollationStatementApproveDto[]>(AcademicMobilityCompetitionService.getCollationStatementForApproval, true);
    const { handleCancel, isModalOpen, showModal } = useModal();
    const [currentAgreement, setCurrentAgreement] = React.useState<CollationStatementApproveDto | null>(null);
    const [form] = Form.useForm();
    const history = useHistory();

    const columns = [
        {
            title: "№",
            dataIndex: "key",
            key: "key"
        },
        {
            title: "Fullname",
            dataIndex: "fullname",
            key: "fullname"
        },
        {
            title: "Group",
            dataIndex: "group",
            key: "group"
        },
        {
            title: "Course",
            dataIndex: "course",
            key: "course"
        },
        {
            title: "University",
            dataIndex: "hostUniversityName",
            key: "hostUniversityName"
        },
        {
            key: "action",
            render: (text: any, record: any) => (
                <Space size={"middle"}>
                    <Button onClick={() => handleOpenModal(record)}>Подтвердить/Отклонить</Button>
                    <Button type="primary" icon={<EyeOutlined />} onClick={() => history.push(`/collation-statement/${record.id}`)}>Просмотреть</Button>
                </Space>
            )
        }
    ];

    const handleOpenModal = (record: any) => {
        setCurrentAgreement(record);
        showModal();
    }

    const handleStatusChange = (values: any) => {
        currentAgreement && AcademicMobilityCompetitionService.collationStatementApprove(currentAgreement.id, values)
            .then(() => {
                successNotification("Статус успешно изменен");
                handleCancel();
                fetchCollationStatements();
            });
    }

    return (
        <Page>
            <Table
                bordered
                columns={columns}
                dataSource={collationStatements?.map((collationStatement, i) => ({
                    key: i + 1,
                    id: collationStatement.id,
                    fullname: collationStatement.student.fullNameKz,
                    group: collationStatement.student.group.title,
                    course: collationStatement.student.courseGrade,
                    hostUniversityName: collationStatement.hostUniversityName,
                    statementId: collationStatement.statementId
                }))}
            />
            <Modal
                title="Accept/Reject"
                open={isModalOpen}
                onOk={form.submit}
                onCancel={handleCancel}
            >
                <Form form={form} onFinish={handleStatusChange}>
                    <Form.Item name="approved" rules={[{ required: true }]}>
                        <Select placeholder="Select status">
                            <Select.Option value="true">Подтвердить</Select.Option>
                            <Select.Option value="false">Отклонить</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name="comment"
                        dependencies={['approved']}
                        rules={[
                            ({ getFieldValue }) => ({
                                required: getFieldValue('approved') === 'false',
                                message: 'Write a comment',
                            }),
                        ]}
                    >
                        <Input.TextArea placeholder="Write a comment" style={{ height: '100px' }} />
                    </Form.Item>
                </Form>
            </Modal>
        </Page>
    )
}

export default CollationStatementPage